<template><div></div></template>

<script>
export default {
  name: "ChatIndexPage",
  mounted() {
    const slug = this.pages
      .filter((p) => p.is_chat_hub)
      .sort((a, b) => a.position - b.position)[0].slug;
    this.$router.push("/" + slug);
  },
};
</script>

